import { FC, FormEventHandler } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Link } from 'dibs-elements/exports/Link';

import styles from './styles/CheckoutEditValue.scss';

type Props = {
    value: string;
    onClick: FormEventHandler;
    emptyValuePlaceholder?: string;
    dataTn: string;
};

export const CheckoutEditValue: FC<Props> = props => {
    const { value, onClick, emptyValuePlaceholder = '', dataTn } = props;

    return (
        <div className={styles.wrapper}>
            <p className={styles.value} data-tn={dataTn}>
                {value || (
                    <span className={styles.emptyValuePlaceholder}>{emptyValuePlaceholder}</span>
                )}
            </p>
            <Link
                className={styles.editButton}
                buyerLinkType="standardLink"
                onClick={onClick}
                dataTn="sidebar-button"
            >
                <FormattedMessage id="checkout.CheckoutEditValue.edit" defaultMessage="Edit" />
            </Link>
        </div>
    );
};
